// DISTILLERY_REGION_SHAPES + distilleryRegionClipPath moved to
// assets/distillery-region-shapes.js (shared with the mega-menu's map — see
// assets/component-mega-menu-map.js) — that file must load before this one.

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.distillery-explorer').forEach(function (explorer) {
    var mapEl = explorer.querySelector('.distillery-explorer__map');
    var triggers = explorer.querySelectorAll('[data-region-trigger]');
    var targets = explorer.querySelectorAll('[data-region-target]');
    var infoEl = explorer.querySelector('[data-region-info]');
    var infoName = explorer.querySelector('[data-region-info-name]');
    var infoDescriptors = explorer.querySelector('[data-region-info-descriptors]');
    var infoKnownForPanels = explorer.querySelectorAll('[data-region-info-known-for]');
    var showcase = explorer.querySelector('[data-region-showcase]');
    var showcasePanels = explorer.querySelectorAll('[data-region-showcase-panel]');
    var awardPanels = explorer.querySelectorAll('[data-award-panel]');
    var awardHeading = explorer.querySelector('[data-award-heading]');
    var awardSection = explorer.querySelector('.distillery-explorer__award-section');
    var switcherPills = explorer.querySelectorAll('[data-region-switcher-pill]');
    var switcherWrap = explorer.querySelector('.distillery-explorer__region-switcher-wrap');

    // Swaps the visible showcase/award panels and syncs the active state across
    // the map, region list, and switcher pills — shared by every entry point
    // (map click, list click, switcher pill click). Does not scroll; callers
    // that need a scroll (map/list) handle that themselves.
    function activateRegion(id, name) {
      if (!showcase || !showcasePanels.length) return null;
      var matched = null;
      showcasePanels.forEach(function (panel) {
        var isMatch = panel.dataset.regionShowcasePanel === id;
        panel.hidden = !isMatch;
        if (isMatch) matched = panel;
      });
      if (!matched) return null;
      showcase.hidden = false;
      selectedId = id;
      setActive(id);
      showAwardPanel(id, name);
      return matched;
    }

    function showRegionShowcase(id, name) {
      var matched = activateRegion(id, name);
      if (!matched) return false;
      (switcherWrap || matched).scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    }

    function showAwardPanel(id, regionName) {
      if (!awardPanels.length) return;
      var matchedPanel = null;
      awardPanels.forEach(function (panel) {
        var isMatch = panel.dataset.awardPanel === id;
        panel.hidden = !isMatch;
        if (isMatch) matchedPanel = panel;
      });
      if (!matchedPanel) {
        // No award panel exists for this region (or nothing selected) — fall back
        // to showing whiskies from all regions.
        awardPanels.forEach(function (panel) {
          var isAll = panel.dataset.awardPanel === 'all';
          panel.hidden = !isAll;
          if (isAll) matchedPanel = panel;
        });
      }
      if (awardHeading) {
        if (matchedPanel && matchedPanel.dataset.awardPanel !== 'all' && regionName) {
          awardHeading.textContent = 'Award Winners from ' + regionName;
        } else {
          awardHeading.textContent = awardHeading.dataset.awardHeadingDefault || awardHeading.textContent;
        }
      }
      if (awardSection) {
        // Some regions have no award-winning whiskies at all (e.g. their collection
        // doesn't overlap with the award-winners collection) — hide the whole band
        // rather than showing an empty slider.
        var count = matchedPanel ? parseInt(matchedPanel.dataset.awardCount || '1', 10) : 0;
        awardSection.hidden = count === 0;
      }
    }

    function showInfo(id, name, descriptors) {
      if (!infoEl) return;
      if (infoName) infoName.textContent = name || '';
      if (infoDescriptors) infoDescriptors.textContent = descriptors || '';
      infoKnownForPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.regionInfoKnownFor !== id;
      });
      infoEl.classList.add('is-visible');
    }

    function hideInfo() {
      if (!infoEl) return;
      infoEl.classList.remove('is-visible');
    }

    var selectedId = null;

    function setActive(id) {
      targets.forEach(function (img) {
        img.classList.toggle('is-active', img.dataset.regionTarget === id);
      });
      triggers.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.regionTrigger === id);
      });
      switcherPills.forEach(function (pill) {
        pill.classList.toggle('is-active', pill.dataset.regionSwitcherPill === id);
      });
    }

    function clearActive() {
      if (selectedId) {
        // A region is currently selected (its showcase panel is displayed below) —
        // keep its rollover style applied instead of clearing back to nothing.
        setActive(selectedId);
      } else {
        targets.forEach(function (img) {
          img.classList.remove('is-active');
        });
        triggers.forEach(function (link) {
          link.classList.remove('is-active');
        });
        switcherPills.forEach(function (pill) {
          pill.classList.remove('is-active');
        });
      }
      hideInfo();
    }

    triggers.forEach(function (link) {
      var id = link.dataset.regionTrigger;
      var name = link.dataset.regionName || '';
      var descriptors = link.dataset.regionDescriptors || '';
      var url = link.dataset.regionUrl || '';

      link.addEventListener('mouseenter', function () {
        setActive(id);
        showInfo(id, name, descriptors);
      });
      link.addEventListener('focus', function () {
        setActive(id);
        showInfo(id, name, descriptors);
      });
      link.addEventListener('mouseleave', clearActive);
      link.addEventListener('blur', clearActive);
      link.addEventListener('click', function (event) {
        if (showRegionShowcase(id, name)) {
          event.preventDefault();
        }
      });
    });

    if (mapEl) {
      targets.forEach(function (img) {
        var id = img.dataset.regionTarget;
        var name = (img.dataset.regionName || '').trim().toLowerCase();
        var displayName = img.dataset.regionName || '';
        var descriptors = img.dataset.regionDescriptors || '';
        var url = img.dataset.regionUrl || '';
        var shapes = DISTILLERY_REGION_SHAPES[name];
        if (!shapes) return;

        // The region overlay PNGs are already pre-clipped to their own territory (transparent
        // everywhere else) — clipping the <img> itself with these percentage polygons was only
        // correct for the older square artwork these shapes were traced against; the current
        // artwork has a different aspect ratio/composition and doesn't need (or match) this
        // clip. The hit-target polygons below are still needed for hover/click detection and
        // are left as-is, even though they're an approximation against the new artwork rather
        // than a pixel-perfect trace.
        shapes.forEach(function (polygon) {
          var hit = document.createElement('a');
          hit.href = url || '#';
          hit.className = 'distillery-explorer__map-hit';
          hit.style.clipPath = 'polygon(' + polygon + ')';
          hit.setAttribute('aria-hidden', 'true');
          hit.setAttribute('tabindex', '-1');

          hit.addEventListener('mouseenter', function () {
            setActive(id);
            showInfo(id, displayName, descriptors);
          });
          hit.addEventListener('mouseleave', clearActive);
          hit.addEventListener('click', function (event) {
            if (showRegionShowcase(id, displayName)) {
              event.preventDefault();
            }
          });

          mapEl.appendChild(hit);
        });
      });
    }

    switcherPills.forEach(function (pill) {
      var id = pill.dataset.regionSwitcherPill;
      var name = pill.dataset.regionName || '';

      pill.addEventListener('click', function () {
        // Already within the expanded content area — switch in place, no scroll.
        activateRegion(id, name);
      });
    });

    // Speyside-only accordion arrow (in the "Most Collected" column) that reveals/hides the pin
    // map + region-info section below the 3-column header. Kept independent of the map's own
    // interior state (pin/cluster selection, zoom, etc. - see section-speyside-pin-map.js) -
    // this only ever toggles the "hidden" attribute on the wrapper; that file's own
    // MutationObserver handles deferring the map's geometry-dependent init until it's revealed.
    explorer.querySelectorAll('[data-speyside-map-toggle]').forEach(function (toggle) {
      var wrap = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!wrap) return;
      toggle.addEventListener('click', function () {
        var opening = wrap.hidden;
        wrap.hidden = !opening;
        toggle.classList.toggle('is-open', opening);
        toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
  });
});
